import { ColumnDef } from '@tanstack/react-table'
import TableCheckbox from '../components/TableCheckbox'

const getCheckboxColumn = <TData,>(): ColumnDef<TData> => ({
    id: 'checkbox',
    size: 40,
    enableSorting: false,
    enableResizing: false,
    meta: {
        thDivClass: 'justify-content-center',
        tdClass: 'text-center align-middle',
        stopPropagation: true,
    },
    header: ({ table }) => (
        <TableCheckbox
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
        />
    ),
    cell: ({ row }) => (
        <TableCheckbox
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            indeterminate={row.getIsSomeSelected()}
            onChange={row.getToggleSelectedHandler()}
        />
    ),
})

export default getCheckboxColumn
